import {
    FETCH_CREATE_SEARCHERS_REQUEST,
    FETCH_CREATE_SEARCHERS_SUCCESS,
    FETCH_CREATE_SEARCHERS_FAILURE,
} from '../../actions/searchers/create-searcher-action';

const initialState = {
    createdSearcher: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const CreateSearcherReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_CREATE_SEARCHERS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_CREATE_SEARCHERS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                createdSearcher: { ...action.payload[0] },
            };
        case FETCH_CREATE_SEARCHERS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default CreateSearcherReducer;